import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { warmRoute } from './App';
import { startVisit } from './lib/visit';
import { preloadLang } from './i18n';
import { startEventClicks } from './lib/event-click';
import './index.css';

startVisit();
// the visitor's language (saved, this session's country, or the browser's guess on a first
// visit): its dictionary chunk downloads while the app hydrates
preloadLang();

const root = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Prerendered pages hydrate; anything served from the SPA fallback renders
// fresh. Hydration mismatches are EXPECTED (build-time "today" vs the
// visitor's clock, geo chips, etc.) — React recovers by re-rendering the
// mismatched tree client-side, so we silence the recoverable-error noise.
if (root.hasChildNodes()) {
  const hydrate = () => ReactDOM.hydrateRoot(root, app, { onRecoverableError: () => {} });
  // A lazy page that is still downloading when React hydrates is thrown away and drawn again (a flash of
  // "Loading…" and a layout shift): fetch the page this address needs first. The server's markup stays on
  // screen meanwhile. Not for long: after 3 s the page hydrates as it always did.
  const warm = warmRoute(location.pathname);
  if (warm) {
    let once = false;
    const go = () => once || ((once = true), hydrate());
    warm.then(go, go);
    setTimeout(go, 3000);
  } else hydrate();
} else {
  ReactDOM.createRoot(root).render(app);
}
// a tap on an event card starts fetching the event's row while the new page renders
startEventClicks();
